
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qmee/privacy-promise",
      function () {
        return require("private-next-pages/qmee/privacy-promise.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qmee/privacy-promise"])
      });
    }
  